import React from "react";
import {FormModalProps} from "../../utils/useFormModal";
import {Form, Input, Modal} from "antd";
import Select from "../../components/Select";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props;

    return (
        <Modal {...otherProps}>
            <Form form={form} layout="vertical">
                <Form.Item name={'country'} label={'Country'} rules={[{required: true, message: 'Please input Country'}]}>
                    <Select url={'/country/dict'} valueField={'country'} textField={'country'}
                            getData={data => data.data}
                            allowClear/>
                </Form.Item>
                <Form.Item name={'company'} label={'Company'} rules={[{required: true, message: 'Please input Company'}]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
